// Scorecard API service
// Centralized API calls for scorecard operations

import axios from 'axios';

const API_BASE_URL = process.env.VUE_APP_DEBUG_MODE === 'true'
    ? 'http://localhost:8080'
    : 'https://axes2api.azurewebsites.net';

export const scorecardService = {
    /**
     * Get a single scorecard by ID
     * @param {string} scorecardId - The scorecard ID
     * @param {string} token - Authorization token
     * @returns {Promise<Object>} Scorecard data
     */
    async getScorecard(scorecardId, token) {
        const response = await axios.get(`${API_BASE_URL}/scorecard/${scorecardId}`, {
            headers: {
                authorization: token
            }
        });
        return response.data;
    },

    /**
     * Get scorecard data as CSV
     * @param {string} scorecardId - The scorecard ID
     * @param {string} token - Authorization token
     * @returns {Promise<Array>} CSV data as array of arrays
     */
    async getScorecardCSV(scorecardId, token) {
        const response = await axios.get(`${API_BASE_URL}/scorecardcsv/${scorecardId}`, {
            headers: {
                authorization: token
            }
        });
        return response.data;
    },

    /**
     * Download scorecard as CSV file
     * @param {Object} scorecard - The scorecard object
     * @param {string} token - Authorization token
     */
    async downloadCSV(scorecard, token) {
        const data = await this.getScorecardCSV(scorecard._id, token);

        // Convert array of arrays to CSV string
        const csvRows = data.map(row =>
            row.map(cell => `"${(cell ?? '').toString().replace(/"/g, '""')}"`).join(',')
        );
        const csvString = csvRows.join('\n');

        // Trigger download
        const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.setAttribute("href", url);
        link.setAttribute("download", `scorecard_${scorecard._id}.csv`);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }
};
